interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  const btn = (active: boolean) =>
    `flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors ${
      active
        ? "bg-primary-500 text-background-50"
        : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
    }`;

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className={`flex h-9 items-center gap-1 rounded-md px-3 text-sm font-medium transition-colors ${
          current <= 1
            ? "cursor-not-allowed bg-background-100 text-foreground-300"
            : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((page) => (
        <button key={page} type="button" onClick={() => onChange(page)} className={btn(page === current)}>
          {page}
        </button>
      ))}

      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className={`flex h-9 items-center gap-1 rounded-md px-3 text-sm font-medium transition-colors ${
          current >= total
            ? "cursor-not-allowed bg-background-100 text-foreground-300"
            : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}